"use client";

import type { PostPrayerStep, Prayer } from "@packages/sdk";
import type { Dispatch, SetStateAction } from "react";
import { createContext, useContext } from "react";

export type PostPrayerOnReflect = (props: { prayer?: Prayer }) => Promise<void>;

export type PostPrayer = {
  trigger: (type: "app-open" | "queue-completion") => Promise<void>;
  steps: PostPrayerStep[];
  clearSteps: () => void;
  onReflect: PostPrayerOnReflect;
  setOnReflect: Dispatch<SetStateAction<PostPrayerOnReflect>>;
};

export const PostPrayerContext = createContext<PostPrayer>({
  trigger: () => Promise.resolve(),
  steps: [],
  clearSteps: () => {},
  onReflect: () => Promise.resolve(),
  setOnReflect: () => {},
});

export const usePostPrayer = () => useContext(PostPrayerContext);
